/**
 * The specification for the Apps Script course's practice sheet.
 *
 * Deliberately independent of the AI track's accounts-payable register. This
 * course stands alone — someone who will never open a terminal should be able
 * to take it — so it brings its own data, its own tab names and its own
 * thresholds rather than importing anything from apDataset.
 *
 * The trainee is given the script rather than asked to write it, and the
 * exercises are: run it, change it, then make it do something on its own. What
 * gets checked is the sheet it produces, never the code text — the same rule
 * the AI track follows, and the only one that survives a trainee writing their
 * script slightly differently to ours.
 */

export const PRACTICE_TAB = 'Script Practice'
export const TOTALS_TAB = 'Totals'

export const PRACTICE_HEADERS = ['Day', 'Units', 'Price', 'Total']
export const BAND_HEADER = 'Band'
export const TOTALS_HEADERS = ['Band', 'Count']

/** What the pasted script produces first time. */
export const STARTING_ROWS = 10

/** What it produces after the trainee edits one line — proof they read it. */
export const EDITED_ROWS = 25

/**
 * Bands for the practice totals. Small numbers on purpose: this sheet is about
 * order lines, not invoices, and reusing the finance thresholds would make
 * every row land in the same band.
 */
export const PRICE_BANDS = [
  { label: 'Large', min: 1000, describes: '$1,000 and over' },
  { label: 'Medium', min: 100, describes: '$100 to $999.99' },
  { label: 'Small', min: 0, describes: 'under $100' },
]

export const BAND_LABELS = PRICE_BANDS.map((b) => b.label)

/** The band a total belongs in, or null if it is not a usable number. */
export function bandForTotal(total) {
  const n = Number(total)
  if (!Number.isFinite(n)) return null
  return PRICE_BANDS.find((b) => n >= b.min)?.label ?? null
}

/** The custom function the trainee builds in the second module. */
export const CUSTOM_FUNCTION = 'PRICEBAND'
